<template>
  <el-form
    ref="form"
    :model="form"
    :inline="true"
    label-width="100px"
    size="mini"
    @submit.prevent="onSubmit"
    style="margin:10px;width:90%;min-width:900px;"
  >
    <el-form-item>
      <strong>接洽信息</strong>
    </el-form-item>	
    <br />
    <el-form-item label="接洽人部门">
      <el-select v-model="form.financeCode" @change="selectGet">
        <el-option v-for="org in organizes" :label="org.OrgName" :value="org.FinanceCode"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="接洽人姓名">
      <el-col>
        <el-input v-model="form.visitedPerson" @blur="getUsers"></el-input>
      </el-col>
    </el-form-item>
    <el-form-item label="电话" v-if="show">
      <el-select v-model="compare">
        <el-option v-for="org in userInfo" :label="org.mobile" :value="org.id"></el-option>
      </el-select>
    </el-form-item>
    <br />
    <el-form-item style="text-align:left">
      <strong>访客信息</strong>
    </el-form-item>
    <br />
    <el-form-item label="访客姓名">
      <el-col>
        <el-input v-model="form.visitor" disabled></el-input>
      </el-col>
    </el-form-item>
    <el-form-item label="身份证号">
      <el-input v-model="form.visitorIdcard" disabled></el-input>
    </el-form-item>
    <el-form-item label="手机号">
      <el-input v-model="form.visitorPhone" disabled></el-input>
    </el-form-item>
    <el-form-item label="来访单位">
      <el-input v-model="form.visitorDep" style="width:510px" disabled></el-input>
    </el-form-item>
    <el-form-item label="预约到访时间">
      <el-date-picker
        v-model="form.visitTime"
        type="date"
        placeholder="选择日期时间"
        :disabled="ifHide"
        :picker-options="pickerOptions1"
      ></el-date-picker>
    </el-form-item>
    <el-form-item label="来访人id" v-if="false">
      <el-input v-model="form.visitPerson" disabled></el-input>
    </el-form-item>
    <el-form-item label="来访原因">
      <el-input
        type="textarea"
        style="width:825px"
        :rows="4"
        v-model="form.visitContent"
        :disabled="ifHide"
      ></el-input>
    </el-form-item>
    <br />
    <el-col :span="24" style="text-align:center">
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :disabled="ifHide">立即创建</el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
import { RequestPost, url, RequestGet } from "../../api/api";
export default {
  data() {
    return {
      form: {
        //来访表
        visitor: "",
        visitorIdcard: "",
        visitorDep: "",
        visitorPhone: "",
        visitTime: "",
        visitContent: "",
        visitedPerson: "",
        visitedDep: "",
        visitPerson: "",
        financeCode: ""
      },
      userInfo: [],
      ifHide: true,
      organizes: [],
      id: "",
      name: "",
      dep: "",
      dept: "",
      compare: "",
      show: false,
       pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < (Date.now() - 8.64e7);
          }}//日期控制
    }
  },
  methods: {
    onSubmit() {
      //提交
      if (this.compare != "") {
        this.form.visitedPerson = this.compare;
      } else {
        this.form.visitedPerson = this.name;
      }
      console.log(sessionStorage);
      //alert(this.form.visitedPerson);
      RequestPost("/visit/saveVisitInfo", this.form).then(response => {
        console.log(this.form);
        if (response.code == "0000") {
          this.$message({
            message: response.message,
            type: "success"
          });
          this.$router.push({ path: "/record" });
        } else {
          this.$message({
            message: response.message,
            type: "error"
          });
        }
      });
    },
    getUsers() {
      //查找部门人员信息
      this.name = this.form.visitedPerson;
      var person = {
        name: this.name,
        dep: this.form.financeCode //财务编码
      };
      if (!(this.name == "" || this.form.financeCode == "")) {
        RequestGet("/user/findByName", person)
          .then(response => {
            //console.log(response.data);
            //console.log(this.userInfo);
            if (response.data.length == 0) {
              this.$message({ message: "查无此人，请重新输入", type: "error" });
              this.ifHide = true;
              this.show = false;
            }
            if (response.data.length == 1) {
              this.$message({ message: "查找成功", type: "success" });
              response.data.forEach(element => {
                this.name = element.id;
              });
              this.ifHide = false;
              this.show = false;
            }
            if (response.data.length > 1) {
              this.$message({ message: "查找成功", type: "success" });
              this.userInfo = response.data;
              this.show = true;
              this.ifHide = false;
            }
          })
          .catch(error => {});
      }
    },
    getOrganize() {
      //获取部门信息
      this.$axios
        .post(url + "/visit/findDept")
        .then(response => {
          this.organizes = JSON.parse(response.data.data).data;
          // console.log( this.organizes);
        })
        .catch(error => {
          // console.log("aaa");
        });
    },
    getLoginInfo() {
      //获取登录人员的信息
      this.id = sessionStorage.getItem("userId");
      this.form.visitPerson = sessionStorage.getItem("userId");
      var person = {
        id: this.id
      };
      RequestGet("/customer/findByid", person)
        .then(response => {
          console.log(response);
          this.form.visitor = response.data.name;
          this.form.visitorIdcard = response.data.idcard;
          this.form.visitorDep = response.data.enterpriseName;
          this.form.visitorPhone = response.data.phone;
        })
        .catch(error => {
          //this.$router.push({ path: '/login' });
        });
    },
    //下拉框选中事件
    selectGet(vId) {
      //这个vId也就是value值
      let obj = {};
      obj = this.organizes.find(org => {
        //这里的organizes就是上面遍历的数据源
        return org.FinanceCode === vId; //筛选出匹配数据
      });
      this.form.visitedDep = obj.OrgName; //我这边的name就是对应label的
      this.getUsers();
    }
  },
  created: function() {
    this.getLoginInfo();
    this.getOrganize();
  }
};
</script>


// WEBPACK FOOTER //
// register.vue?255f77e4